import React, {useState} from 'react';

import {v4} from 'uuid';

import {getContentType} from 'app/utils/content-type';

import {PermitOpenaiDataGathering} from './PermitOpenaiDataGathering';
import {SuggestionChat} from './SuggestionChat';

import type {SuggestionItem} from 'app/openai/types';
const DEFAULT_SUGGESTED_TITLES: Array<SuggestionItem> = [
  {
    name: 'Secure Payment Processing',
    content_type: 'procedure',
    command: 'actions',
  },
  {
    name: 'Product Delivery Tracking',
    content_type: 'procedure',
    command: 'actions',
  },
  {
    name: 'Customer Service Response',
    content_type: 'procedure',
    command: 'actions',
  },
  {name: 'Privacy Protection', content_type: 'policy', command: 'actions'},
  {name: 'Return and Refund', content_type: 'policy', command: 'actions'},
  {
    name: 'Product Information Accuracy',
    content_type: 'policy',
    command: 'actions',
  },
];

type Props = {
  contentTypePlural: 'procedures' | 'policies';
  contentType: 'procedure' | 'policy';
  onClick: (string) => void;
};
export const TitleSuggestions = ({
  contentTypePlural,
  contentType,
  onClick,
}: Props) => {
  const [titles, setTitles] = useState<null | Array<SuggestionItem>>(
    DEFAULT_SUGGESTED_TITLES.filter((suggestedTitle) => {
      return suggestedTitle.content_type === contentType;
    })
  );
  const [threadId] = useState(v4());

  return (
    <>
      <div className="row">
        <div className="col">
          <div className="lead">
            <PermitOpenaiDataGathering />
          </div>
        </div>
      </div>

      <SuggestionChat
        initialThreadId={threadId}
        contentType={contentTypePlural}
        setResults={setTitles}
      >
        <ul className="list-group mt-4">
          {titles?.map((doc, i) => (
            <DocItem
              key={`${doc}-${i}`}
              doc={doc.name}
              content_type={doc.content_type}
              onClick={onClick}
            />
          ))}
        </ul>
      </SuggestionChat>
    </>
  );
};

type SelectProps = {
  doc: string;
  content_type: 'procedure' | 'policy';
  onClick: (string) => void;
};

const DocItem = ({doc, content_type, onClick}: SelectProps) => {
  const ct = getContentType(content_type);

  return (
    <li className="list-group-item list-group-item-action flex-column align-items-start">
      <div
        className="d-flex w-100 justify-content-between"
        onClick={() => onClick(doc)}
        role="button"
      >
        <h5>
          <i className={`mr-1 ${ct.icon}`} />
          {doc}
        </h5>
      </div>
    </li>
  );
};
